export default "/institutions/recargapay.svg";